<template>
  <span
    v-if="isResultTogglerVisible"
    class="result_toggle_item hover-item"
    id="result-toggler"
    @click="toggleResult(inputMethods.MOUSE)"
    v-tooltip="hideResultTooltip"
    @mouseleave="offResultTooltip"
  >
    <aha-icon
      class="show-result-icon"
      width="24"
      height="24"
      v-if="!isShowingResult"
      name="show_result"
      viewBox="0 0 24 24"
    ></aha-icon>
    <aha-icon
      v-else
      width="24"
      height="24"
      name="hide_result"
      viewBox="0 0 24 24"
    ></aha-icon>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import { INPUT_METHODS } from '@/constant/inputMethods.constants'
import { KEYCODES } from '@/constant/keycode.constant'

const DEFAULT_TIME_CLOSE_TOOLTIP = 3000
export default {
  name: 'ResultAndAnswerToggler',
  props: {
    isResultTogglerVisible: {
      type: Boolean,
      default: false,
    },
    isShowingResult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDisplayRevealResultTooltip: false,
      inputMethods: INPUT_METHODS,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    hideResultTooltip() {
      let content = this.isShowingResult ? this.$i18nPresenter.t('Hide results') : this.$i18nPresenter.t('Show results')
      content += ' (H)'
      return {
        show: this.isDisplayRevealResultTooltip,
        content,
      }
    },
  },
  watch: {
    isDisplayRevealResultTooltip() {
      if (this.isDisplayRevealResultTooltip) {
        setTimeout(() => {
          this.isDisplayRevealResultTooltip = false
        }, DEFAULT_TIME_CLOSE_TOOLTIP)
      }
    },
  },
  mounted() {
    EventBus.$on('display-hide-result-pill-tooltip', () => {
      this.isDisplayRevealResultTooltip = true
    })
    this.registerHotkey()
  },
  destroyed() {
    EventBus.$off('display-hide-result-pill-tooltip')
    this.isDisplayRevealResultTooltip = false
    this.unregisterHotKey()
  },
  methods: {
    registerHotkey() {
      EventBus.$on('onKeyboard', this.handleHotkey)
    },
    unregisterHotKey() {
      EventBus.$off('onKeyboard', this.handleHotkey)
    },
    handleHotkey(e) {
      if (e.keyCode !== KEYCODES.H) return
      if (!this.isPresenting) return
      this.toggleResult(INPUT_METHODS.KEYBOARD)
    },
    toggleResult(method) {
      this.$emit('toggleResult', !this.isShowingResult, method)
    },
    offResultTooltip() {
      this.isDisplayRevealResultTooltip = false
    },
  },
}
</script>

<style lang="scss" >

.result_toggle_item {
  cursor: pointer;
  margin-left: 20px;
  display: inline-block;
}
.hover-item {

  position: relative;
  &:hover::after{
      opacity: 1;
  }
  &::after {
    content: "";
    position: absolute;
    opacity: 0;
    transition: all 0.3s ease;
    background: #ebebeb;
    z-index: -1;

    width: 36px;
    height: 36px;
    border-radius: 50%;
    top: -4px;
    left: -6px;
    }

}

.show-result-icon {
  width: 24px;
  height: 24px;
}
</style>
